import { Match } from 'effect';

/**
 * A parameter's value as one string. A backend can send a measurement as a
 * number (`35`, `73.1`), a select as a string array (`['18']`), or plain
 * text — every shape reads as one string here. The number formatter is a
 * parameter because this module carries no intl of its own.
 */
export const formatAttributeValue = (
  value: string | number | ReadonlyArray<string>,
  formatNumber: (value: number) => string
): string =>
  Match.value(value).pipe(
    Match.when(Match.string, (text) => text),
    Match.when(Match.number, (amount) => formatNumber(amount)),
    Match.orElse((values) => values.join(', '))
  );
